var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.082 1.58882C10.4236 1.63241 9.74692 1.72985 9.21709 1.85549C6.52856 2.49139 4.18365 4.09652 2.66758 6.3401C0.847252 9.03241 0.380367 12.4452 1.41119 15.5016C2.10102 17.5401 3.37053 19.2914 5.12266 20.6222C7.11348 22.135 9.75479 22.9375 12.2859 22.7991C13.844 22.7145 15.1581 22.3786 16.5377 21.717C17.6761 21.1709 18.5732 20.5375 19.4676 19.6504C20.1495 18.9709 20.6007 18.4016 21.0886 17.6016C22.9666 14.5222 23.1056 10.6478 21.4532 7.42728C20.7371 6.03754 19.6958 4.79139 18.4263 3.81703C16.9941 2.71446 15.1581 1.94011 13.3928 1.69139C12.6427 1.5837 11.7482 1.54523 11.082 1.58882ZM12.3148 3.12985C14.6099 3.276 16.682 4.18882 18.2925 5.75805C20.3961 7.80934 21.364 10.6683 20.9286 13.5375C20.4774 16.4965 18.5391 19.0683 15.7771 20.3709C12.5902 21.8734 8.83414 21.4863 6.04069 19.3657C3.33643 17.3145 2.00922 13.9863 2.57315 10.6786C2.86692 8.95805 3.69578 7.30677 4.89709 6.0478C6.0302 4.86062 7.35217 4.02985 8.86037 3.55293C10.0197 3.18882 11.1318 3.05293 12.3148 3.12985Z",
    fill: "#F44336",
    stroke: "#B23E3E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5541 7.50453C11.3311 7.5635 11.1082 7.75068 11.0164 7.95837C10.9692 8.06094 10.9665 8.17888 10.9613 10.2097L10.9561 12.3507L11.0216 12.4891C11.1134 12.6866 11.2052 12.7789 11.3888 12.8686C11.8006 13.0712 12.3147 12.8763 12.4721 12.4584C12.522 12.325 12.522 12.2558 12.5141 10.1917L12.5062 8.0635L12.4485 7.93529C12.3724 7.77632 12.2203 7.62504 12.0656 7.55581C11.9502 7.50453 11.659 7.47632 11.5541 7.50453Z",
    fill: "#F44336",
    stroke: "#B23E3E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5334 15.3931C11.3603 15.4418 11.2134 15.5418 11.1137 15.6802C10.9983 15.8418 10.9695 15.9315 10.9668 16.1392C10.9642 16.4367 11.119 16.6777 11.4022 16.8213C11.5072 16.8726 11.5649 16.8828 11.7511 16.8828C11.995 16.8802 12.0737 16.852 12.2678 16.7008C12.5983 16.4367 12.614 15.8982 12.2967 15.5905C12.1078 15.4059 11.7852 15.3238 11.5334 15.3931Z",
    fill: "#F44336",
    stroke: "#B23E3E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/Alert.2d535ce99be7204143d23d82ce298e01.svg";
export { ForwardRef as ReactComponent };